import { SminexClubSearchFilters } from './types';

const formatSearchString = (value: string): string => JSON.stringify(value);

const formatBoolean = (value: boolean): string => (value ? 'true' : 'false');

const formatProjects = (codes: string[]): string => `[${codes.map((code) => JSON.stringify(code)).join(', ')}]`;

interface SminexClubSearchPagination {
  page: number;
  pageSize: number;
}

export const buildSminexClubSearchSubscription = (
  filters: SminexClubSearchFilters,
  pagination: SminexClubSearchPagination,
  segment = 'CB'
) => {
  const filterParts = [`segment: ${segment}`, `page: ${pagination.page}`, `pageSize: ${pagination.pageSize}`];

  if (filters.searchString) {
    filterParts.push(`searchString: ${formatSearchString(filters.searchString)}`);
  }

  if (filters.projectCodes.length) {
    filterParts.push(`projects: ${formatProjects(filters.projectCodes)}`);
  }

  if (filters.isBroker !== null) {
    filterParts.push(`isBroker: ${formatBoolean(filters.isBroker)}`);
  }

  if (filters.callRefusal !== null) {
    filterParts.push(`callRefusal: ${formatBoolean(filters.callRefusal)}`);
  }

  if (filters.dealsSummFrom !== null) {
    filterParts.push(`dealsSummFrom: ${filters.dealsSummFrom}`);
  }

  if (filters.dealsSummTo !== null) {
    filterParts.push(`dealsSummTo: ${filters.dealsSummTo}`);
  }

  return `
  subscription UsersUpdates {
    usersUpdates(
      filters: { ${filterParts.join(', ')} }
    ) {
      clients {
        id
        firstName
        lastName
        surname
        manager
        broker
        callRefusal
        projects
      }
    }
  }
`;
};

export interface SminexClubSearchClientPayload {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  surname?: string | null;
  manager?: string | null;
  broker?: string | null;
  callRefusal?: boolean | null;
  projects?: Array<string | null> | null;
}

export interface SminexClubSearchPayload {
  usersUpdates?: {
    clients?: Array<SminexClubSearchClientPayload | null> | null;
  } | null;
}
